/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const resourceBulkEmploymentTypeRequestSchema = z.object({
  employmentType: z.enum(['EMPLOYEE', 'CONTRACTOR', 'PARTNER', 'ON_DEMAND', 'AI_AGENT']),
  resourceIds: z.array(z.int()).min(1).max(100),
});
